import * as React from "react";
import * as ReactDOM from "react-dom";
import { FC } from "react";
import { Control } from "ol/control";
import { config } from "../config";

export const Download: FC<{ this: Control }> = (props) => {
    const onClick = () => window.open(config.default.dataDownloadUrl, "_blank").focus();

    return (
        <div className="download-button" onClick={onClick} title={"LVM datu lejupielāde"}>
            <span className="icon-zemesnoma-cloud-download" />
        </div>
    );
};

export class DownloadButton extends Control {
    constructor() {
        const element = document.createElement("div");
        element.className = "zemesnoma-map-button download-container ol-unselectable ol-control";
        super({
            element
        });
        ReactDOM.render(<Download this={this} />, element);
    }
}
